<!-- WRAPPER GRIS -->
<div style="display: flex; flex-direction: column;">

  <div class="min-h-screen bg-gray-100">

    <!-- HEADER -->
    <header class="w-full bg-gray-100">
      <div class="mx-auto max-w-6xl px-3 py-0 m-0 grid grid-cols-[1fr_auto] grid-rows-[auto_auto] relative">

        <div class="col-span-2">

          <!-- Ligne horaire + langue -->
          <div class="flex items-center justify-between m-0 -mt-6">

            <!-- Heure -->
            <div class="text-sm">
              {{ currentTime | date:'EEE d MMM, HH:mm:ss':'fr-CA' }}
            </div>

            <!-- Logo centré -->
            <div class="flex-1 flex justify-center mt-2 -mb-2">
              <div class="flex flex-col items-center select-none">
                <img src="/assets/images/Logo-Matwins.png" alt="Logo Matwins" class="w-40 h-24 object-contain">
              </div>
            </div>

            <!-- Change language -->
            <div class="flex items-center space-x-4 ml-auto">
              <!-- Language dropdown -->
              <div class="relative flex justify-end mr-[10px]" (clickOutside)="closeLangMenu()">
                <button (click)="toggleLangMenu()" class="px-2 py-1 bg-transparent text-xs text-gray-700 flex items-center">
                  <i class="fa-solid fa-language mr-1"></i>
                  <i class="fas fa-globe mr-2"></i>
                  <i class="fas fa-chevron-down ml-1"></i>
                </button>

                @if (langMenuOpen) {
                  <div class="absolute top-full right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg z-50">
                    <!-- Boucle sur les langues disponibles -->
                    @for (lang of languages; track lang.key) {
                      <button (click)="changeLanguage(lang.key)" [class.bg-blue-50]="currentLanguage === lang.key"
                        class="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center">
                        <!-- Utilisation du logoPath si disponible, sinon emoji de fallback -->
                        @if (lang.logoPath) {
                          <img [src]="lang.logoPath" [alt]="lang.name" class="w-4 h-4 mr-2 object-contain">
                        } @else {
                          <span class="mr-2">{{ getFlagEmoji(lang.key) }}</span>
                        }
                        {{ lang.name }} ({{ lang.key }})
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- Bouton Précédent -->
        <div class="row-start-2 justify-self-start self-end mt-2">
          @if (canGoBack()) {
            <button
              (click)="goBack()"
              class="bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-sm shadow-md">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="white" stroke-width="2" class="h-6 w-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15 19l-7-7 7-7" />
                </svg>
              </button>
            }
          </div>

          <!-- Operation message (toujours affiché) -->
          <div class="row-start-2 justify-self-end self-end mt-2">
            <span class="p-2 px-10 text-xl text-center rounded bg-blue-100 border border-2 text-gray-500 font-bold">
              {{ (navService.getCurrentPageName() == undefined ? 'No Operation' : navService.getCurrentPageName() || '') | translate }}
            </span>
          </div>
        </div>

      </header>

      <!-- ROUTER -->
      <main class="mx-auto max-w-6xl px-0 py-0 [@media(min-width:750px)]:p-3 sm:py-4 min-w-[320px]">
        <router-outlet></router-outlet>
      </main>
      <!-- Loader full-screen moderne -->
      @if (loaderService.loading$ | async) {
        <div
          class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-[9999] animate-fadeIn">
          <div class="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center space-y-4 animate-slideIn">
            <!-- Spinner animé -->
            <div class="relative">
              <div class="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin border-t-blue-500"></div>
              <div class="absolute inset-0 w-16 h-16 border-4 border-transparent rounded-full animate-ping border-t-blue-300"></div>
            </div>
            <!-- Texte de chargement -->
            <p class="text-gray-700 font-medium text-lg">{{ 'app.loading' | translate }}</p>
            <div class="w-32 h-1 bg-gray-200 rounded-full overflow-hidden">
              <div class="h-full bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>